import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M52.96 22.8718C52.06 14.2518 46.46 7.47176 38.99 3.34176C31.48 -0.798236 12.26 1.81176 12.26 1.81176L14.89 3.02176C14.89 3.02176 13.01 3.42176 10.58 4.84176C8.14 6.26176 6.64 7.67176 6.64 7.67176L9.03001 8.61176C4.89001 12.7118 2.39 17.3218 1.77 23.2618C0.73 33.1718 4.46 56.3918 4.46 56.3918C4.46 56.3918 3.16997 35.0318 7.48997 25.3418C8.75997 22.4818 11.28 20.0618 11.28 20.0618C11.28 20.0618 17.53 22.9218 25.4 22.4418C30.87 22.1118 43.22 20.2718 43.22 20.2718C43.22 20.2718 46.41 21.7018 48.19 27.5418C51.86 39.5718 50.4 56.3818 50.4 56.3818C50.4 56.3818 54 32.7818 52.96 22.8718Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M33.2001 21.7519C31.2801 19.7019 29.2601 17.9519 26.9301 16.7119C25.7901 16.0719 24.57 15.5519 23.29 15.1819C22.02 14.7519 20.69 14.5619 19.29 14.2719C20.66 13.9419 22.12 13.8119 23.54 14.0419C24.27 14.1019 24.95 14.3319 25.66 14.5219C26.33 14.7819 27.0201 15.0419 27.6501 15.4019C28.9201 16.1119 30.0801 17.0119 31.0301 18.0919C31.9801 19.1619 32.7701 20.3919 33.2001 21.7519Z"
        fill={outline}
      />
      <path
        d="M16.6599 18.0118C17.5799 17.8818 18.5099 17.9618 19.4199 18.1318C20.3299 18.3018 21.2199 18.6118 22.0699 19.0018C22.9099 19.4218 23.6899 19.9618 24.3599 20.6218C25.0299 21.2818 25.5499 22.1018 25.8599 22.9618C25.1899 22.3118 24.5699 21.7118 23.8499 21.2118C23.1399 20.7218 22.4099 20.2618 21.6199 19.8918C20.0699 19.1318 18.4099 18.5718 16.6599 18.0118Z"
        fill={outline}
      />
      <path
        d="M19.6699 16.5918C20.5899 16.4618 21.5199 16.5418 22.4299 16.7118C23.3399 16.8818 24.23 17.1918 25.08 17.5818C25.92 18.0018 26.6999 18.5418 27.3699 19.2018C28.0399 19.8618 28.5599 20.6818 28.8699 21.5418C28.1999 20.8918 27.5799 20.2918 26.8599 19.7918C26.1499 19.3018 25.4199 18.8418 24.6299 18.4718C23.0699 17.7118 21.4099 17.1618 19.6699 16.5918Z"
        fill={outline}
      />
      <path
        d="M30.6401 9.73169C31.7501 10.1317 32.7701 10.7717 33.7001 11.5017C34.6401 12.2417 35.4601 13.1217 36.1701 14.1017C36.8501 15.1017 37.3701 16.2217 37.6401 17.4017C37.9301 18.5817 37.8601 19.8217 37.5801 20.9617C37.4401 19.7817 37.2901 18.6717 36.8901 17.6217C36.4901 16.5817 35.9901 15.5817 35.3501 14.6717C34.0601 12.8317 32.4301 11.2517 30.6401 9.73169Z"
        fill={outline}
      />
      <path
        d="M44.76 22.1118C45.41 21.3318 46.08 20.6018 46.8 19.9118C47.17 19.5718 47.54 19.2318 47.94 18.9418C48.35 18.6618 48.79 18.3618 49.29 18.3218C48.81 18.4418 48.45 18.7918 48.1 19.1318C47.76 19.4818 47.46 19.8618 47.17 20.2518C46.59 21.0318 46.06 21.8618 45.58 22.6918L44.76 22.1118Z"
        fill={outline}
      />
      <path
        d="M49.7699 21.8418C49.1599 22.0218 48.6099 22.3618 48.1899 22.7818C47.7599 23.2018 47.4799 23.7218 47.3099 24.2518L46.3999 23.8218C46.7799 23.2218 47.2899 22.7118 47.8899 22.3718C48.4799 22.0418 49.1299 21.8618 49.7699 21.8418Z"
        fill={outline}
      />
    </g>
  )
}
